import React, { Component } from "react";
import {
  FlatButton,
  SelectField,
  MenuItem,
  label,
  Menu,
  TextField,
  Card,
  CardTitle,
  IconButton,
  AppBar,
  Dialog,
} from "material-ui";
import {
  FormsyRadioGroup,
  FormsyRadio,
  FormsyText,
} from "formsy-material-ui/lib";
import Formsy from "formsy-react";
import Loading from "../Loading";
import Dropzone from "react-dropzone";
import { Link } from "react-router";
import ApiQueue from "../../../utils/api-queue";
import ReactTooltip from "react-tooltip";

import deleteDefaultIcon from "../../images/delete_default.png";
import editDefaultIcon from "../../images/edit_default.png";
import ShowMailingList from "./ShowMailingList";
import ShowGroupList from "./ShowGroupList";
import ShowUserList from "./ShowUserList";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import searchIcon from "../../images/search.png";
import sendIcon from "../../images/send_icon.png";
import { sendgridTemplateList } from "../helpers";

class ShowPackageList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      message: "Click to upload file, or drag and drop file",
      isLoading: false,
      mailingTypeUserList: [],
      showPackageFlag: false,
      data: "",
      showPopUp: "",
      currentRow: "",
      openDeleteConfirmPopup: false,
      currentSelectedRow: {},
    };
    this.apiQueue = new ApiQueue(this.getSearchMessageCallback);
    this.ButtonFormatter = this.ButtonFormatter.bind(this);
    this.groupNameFormatter = this.groupNameFormatter.bind(this);
    this.userNameFormatter = this.userNameFormatter.bind(this);
    this.closeShowPopup = this.closeShowPopup.bind(this);
  }

  componentDidMount() {
    this.getAllDocUploader();
    this.getAllMailingType();
  }

  ButtonFormatter(cell, row) {
    return (
      <div>
        <IconButton
          onClick={() => {
            this.sendEmail(row);
          }}
          style={{
            width: "25px",
            height: "25px",
            padding: "0px",
            paddingLeft: "15px",
          }}
        >
          <p data-tip="Send Email" data-for="sendEmailTooltip">
            <img src={sendIcon} />
          </p>
          <ReactTooltip id="sendEmailTooltip" />
        </IconButton>
        <IconButton
          onClick={() => {
            this.editPackage(row);
          }}
          style={{
            width: "25px",
            height: "25px",
            padding: "0px",
            paddingLeft: "15px",
          }}
        >
          <p data-tip="Edit" data-for="editPackage">
            <img src={editDefaultIcon} />
          </p>
          <ReactTooltip id="editPackage" />
        </IconButton>
        <IconButton
          onClick={() => {
            this.deletePackageBtn(row);
          }}
          style={{ width: "25px", height: "25px", paddingLeft: "20px" }}
        >
          <p data-tip="Delete" data-for="deletePackage">
            <img src={deleteDefaultIcon} />
          </p>
          <ReactTooltip id="deletePackage" />
        </IconButton>
      </div>
    );
  }

  groupNameFormatter(cell, row) {
    let groupCount =
      row.groupList.length > 1
        ? " +" + (row.groupList.length - 1) + " Group(s)"
        : "";
    let firstGroupName =
      row.groupList.length > 0 ? row.groupList[0].name + groupCount : "";
    return (
      <a
        onClick={() => {
          this.showGroupListMethod(row);
        }}
        style={{ cursor: "pointer" }}
      >
        <span>{firstGroupName}</span>
      </a>
    );
  }

  userNameFormatter(cell, row) {
    let userCount =
      row.userList.length > 1
        ? " +" + (row.userList.length - 1) + " User(s)"
        : "";
    let firstUserEmail =
      row.userList.length > 0 ? row.userList[0].email + userCount : "";
    return (
      <a
        onClick={() => {
          this.showUserListMethod(row);
        }}
        style={{ cursor: "pointer" }}
      >
        <span>{firstUserEmail}</span>
      </a>
    );
  }

  showGroupListMethod(row) {
    this.setState({ showPopUp: "SHOW_GROUP_LIST", currentRow: row });
  }

  showUserListMethod(row) {
    this.setState({ showPopUp: "SHOW_USER_LIST", currentRow: row });
  }

  editPackage = (row) => {
    this.setState({ showPackageFlag: true, currentSelectedRow: row });
  };

  sendEmail = (row) => {
    var me = this;
    console.log("row-------------", row);
    let selectedRow = [];
    row.groupList.forEach(function (groupObj) {
      selectedRow.push(groupObj._id);
    });

    console.log("selectedRow--------", selectedRow);
    let formData = new FormData();
    formData.append("name", row.name);
    formData.append("note", row.note ? row.note : "");
    formData.append("mailing_list_ids", selectedRow);
    formData.append("email_template", row.emailTemplateId);
    formData.append("isSave", false);

    let url = `/api/documentUpload/addDocUploaderType`;
    let options = {
      method: "POST",
      dataType: "json",
      headers: {
        token: this.props.token.jwt,
      },
      body: formData,
    };
    fetch(url, options).then((res) => {
      if (res.status >= 200 && res.status < 300) {
        alert("Email sent successfully.");
      } else {
        this.notifyFormError(res, "Internal server error.");
      }
    });
  };

  deletePackageBtn = (row) => {
    this.setState({ openDeleteConfirmPopup: true, currentSelectedRow: row });
  };

  closeDeleteConfirmPopup = () => {
    this.setState({ openDeleteConfirmPopup: false, currentSelectedRow: {} });
  };

  deletePackage = () => {
    let { currentSelectedRow } = this.state;
    var me = this;
    let url = `/api/documentUpload/deletePackage/${currentSelectedRow._id}`;
    let options = {
      method: "delete",
      headers: {
        token: this.props.token.jwt,
      },
    };
    fetch(url, options)
      .then((res) => {
        if (res.status >= 200 && res.status < 300) {
          me.getAllMailingType();
        }
      })
      .then((json) => {
        me.setState({ openDeleteConfirmPopup: false, currentSelectedRow: {} });
        me.getAllDocUploader();
      });
  };

  closeShowPopup() {
    this.setState({ showPopUp: "", currentRow: "" });
  }

  getAllDocUploader = (searchText) => {
    this.setState({ isLoading: true });
    let url = `/api/documentUpload/getDocUploader`;
    if (searchText) {
      url = `/api/documentUpload/getDocUploader?searchText=` + searchText;
    }

    let options = {
      headers: {
        token: this.props.token.jwt,
      },
    };
    fetch(url, options)
      .then((res) => {
        if (res.status >= 200 && res.status < 300) return res.json();
      })
      .then((json) => {
        let docUploader = [];
        json.docUploader.forEach(function (docUploadObj) {
          let emailTemplate = "";
          sendgridTemplateList.map((sendgridTemplateListData, index) => {
            if (
              sendgridTemplateListData.id ==
              docUploadObj.docUploader.email_template
            ) {
              emailTemplate = sendgridTemplateListData;
            }
          });
          let result = docUploadObj.userDataList.reduce((unique, o) => {
            if (
              !unique.some((obj) => obj._id.toString() === o._id.toString())
            ) {
              unique.push(o);
            }
            return unique;
          }, []);
          let map = {
            name: docUploadObj.docUploader.name,
            _id: docUploadObj.docUploader._id,
            emailTemplate: emailTemplate ? emailTemplate.name : "",
            emailTemplateId: emailTemplate ? emailTemplate.id : "",
            groupList: docUploadObj.groupList,
            userList: result,
          };
          docUploader.push(map);
        });
        this.setState({ isLoading: false, docUploader: docUploader });
      });
  };

  getAllMailingType = (data) => {
    if (data) {
      this.getMessagesAccordingToSearch(data);
    } else {
      let url = `/api/documentUpload/getMailingTypeList`;
      let options = {
        headers: {
          token: this.props.token.jwt,
        },
      };
      fetch(url, options)
        .then((res) => {
          if (res.status >= 200 && res.status < 300) return res.json();
        })
        .then((json) => {
          this.setState({
            isLoading: false,
            mailingTypeList: json.mailingTypeList,
          });
        });
    }
  };

  getMessagesAccordingToSearch = (searchText) => {
    let token = this.props.token.jwt;
    let body = {
      extraParameter: { searchText, token },
    };
    this.apiQueue.addOperation(body);
  };

  getSearchMessageCallback = (type, result, extraParameter) => {
    var me = this;
    if (type == "SUCCESS") {
      me.setState({ isLoading: false, mailingTypeList: result });
    }
  };

  deleteMailingList = (row) => {
    var me = this;
    let url = `/api/documentUpload/deleteMailingType/${row._id}`;
    let options = {
      method: "delete",
      headers: {
        token: this.props.token.jwt,
      },
    };
    fetch(url, options)
      .then((res) => {
        if (res.status >= 200 && res.status < 300) {
          me.getAllMailingType();
        }
      })
      .then((json) => {
        this.setState({ isLoading: false });
      });
  };

  showMailingList = () => {
    this.setState({ showPackageFlag: true, currentSelectedRow: {} });
  };

  showPackageList = () => {
    this.setState({ showPackageFlag: false, currentSelectedRow: {} });
    this.getAllDocUploader();
  };

  deleteMailingList = (row) => {
    var me = this;
    let url = `/api/documentUpload/deleteMailingType/${row._id}`;
    let options = {
      method: "delete",
      headers: {
        token: this.props.token.jwt,
      },
    };
    fetch(url, options)
      .then((res) => {
        if (res.status >= 200 && res.status < 300) {
          me.getAllMailingType();
        }
      })
      .then((json) => {
        this.setState({ isLoading: false });
      });
  };

  // This method is used for searching
  submitSearchForm(searchText) {
    var me = this;
    if (searchText != "" && searchText != null) {
      me.getAllDocUploader(searchText.trim());
      this.setState({ isLoading: false, searchTextValue: searchText.trim() });
    } else {
      this.setState({ searchTextValue: "" });
      me.getAllDocUploader("");
    }
  }

  render() {
    let {
      docUploader,
      showPackageFlag,
      showPopUp,
      currentRow,
      openDeleteConfirmPopup,
    } = this.state;
    if (this.state.isLoading) {
      return (
        <div className="container">
          <center>
            <Loading color={"#000"} />
          </center>
        </div>
      );
    }
    return (
      <div className="containerbody">
        <div
          style={{
            padding: "0px 15px",
            display: showPackageFlag ? "none" : "block",
          }}
        >
          <div style={{ margin: "0.5em" }}>
            <span className="companyListTitle">Email Porter</span>
          </div>
          <div>
            <div className="searchTextCls" style={{ display: "inline-block" }}>
              <input
                type="text"
                value={this.state.searchTextValue}
                className="searchInputCls"
                placeholder="Search Package Name"
                onChange={(e) => this.submitSearchForm(e.target.value)}
              />
              <span
                className="searchImgCls"
                onClick={() => {
                  this.clearSearchText();
                }}
              >
                <img src={searchIcon} style={{ width: "16px" }} />
              </span>
            </div>
            <div style={{ display: "inline-block", float: "right" }}>
              <FlatButton
                onClick={this.showMailingList}
                className="flatButtonCls"
                style={{ width: "120px" }}
              >
                Add Package
              </FlatButton>
            </div>
          </div>
          <BootstrapTable data={docUploader} bordered={false} pagination>
            <TableHeaderColumn
              isKey={true}
              dataField="_id"
              width="120"
              hidden={true}
            >
              Id
            </TableHeaderColumn>
            <TableHeaderColumn
              dataField="name"
              width="80"
              tdStyle={{ background: "#fff" }}
            >
              Package Name
            </TableHeaderColumn>
            <TableHeaderColumn
              dataField="emailTemplate"
              width="120"
              tdStyle={{ background: "#fff" }}
            >
              Email Template
            </TableHeaderColumn>
            <TableHeaderColumn
              dataField="groupList"
              dataFormat={this.groupNameFormatter}
              width="80"
              tdStyle={{ background: "#fff" }}
            >
              Group Name
            </TableHeaderColumn>
            <TableHeaderColumn
              dataField="userList"
              dataFormat={this.userNameFormatter}
              width="120"
              tdStyle={{ background: "#fff" }}
            >
              User List
            </TableHeaderColumn>
            <TableHeaderColumn
              dataField="button"
              dataFormat={this.ButtonFormatter}
              width="40"
              tdStyle={{ background: "#fff" }}
            >
              Action
            </TableHeaderColumn>
          </BootstrapTable>
        </div>
        <Dialog
          title="Delete Package List"
          open={openDeleteConfirmPopup}
          onRequestClose={this.closeDeleteConfirmPopup}
          style={{
            width: "50%",
            textAlign: "center",
            left: "25%",
            zIndex: openDeleteConfirmPopup ? "1500" : "-1",
          }}
        >
          Are you sure you want to delete this Package?
          <br />
          <br />
          <FlatButton
            type="button"
            className="flatButtonCls"
            onTouchTap={this.deletePackage}
          >
            Yes
          </FlatButton>
          <FlatButton
            type="button"
            style={{ marginLeft: "2rem" }}
            className="flatButtonCls"
            onTouchTap={this.closeDeleteConfirmPopup}
          >
            No
          </FlatButton>
        </Dialog>
        <ShowMailingList
          mailingTypeList={this.state.mailingTypeList}
          open={showPackageFlag}
          token={this.props.token.jwt}
          showPackageList={this.showPackageList}
          data={this.state.currentSelectedRow}
          getAllMailingType={this.getAllMailingType}
          deleteMailingList={this.deleteMailingList}
        />
        <ShowGroupList
          open={showPopUp == "SHOW_GROUP_LIST" ? true : false}
          groupList={currentRow.groupList}
          closeShowPopup={this.closeShowPopup}
        />
        <ShowUserList
          open={showPopUp == "SHOW_USER_LIST" ? true : false}
          userList={currentRow.userList}
          closeShowPopup={this.closeShowPopup}
        />
      </div>
    );
  }
}

export default ShowPackageList;



// WEBPACK FOOTER //
// ./app/components/documentUploader/ShowPackageList.js